import PropTypes from "prop-types";
import ProductRatingContainer from "app/pages/FicheProduit/components/ProductRating/ProductRatingContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./HotelHeader.scss";
import { memo } from "react";
import ProductSummaryContainer from "app/pages/.shared/ProductSummary/ProductSummaryContainer";

const HotelHeader = ({ hotelName, tripAdvisorData = {}, holidayCheckData = {} }) => {
	return (
		<div className="hotel-header">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL2}
				isBold
				className="hotel-header__name"
				data-testid="hotel-name"
				component="div"
			>
				{hotelName}
			</Typography>

			<ProductRatingContainer
				locationName={hotelName}
				tripAdvisor={tripAdvisorData}
				holidayCheck={{
					...holidayCheckData,
					size: "large",
					isCompact: true,
				}}
			/>

			<ProductSummaryContainer />
		</div>
	);
};

HotelHeader.propTypes = {
	hotelName: PropTypes.node.isRequired,
	tripAdvisorData: PropTypes.object,
	holidayCheckData: PropTypes.object,
};

export default memo(HotelHeader);
